import { render, staticRenderFns } from "./iconTour.vue?vue&type=template&id=7c7d7f34"
import script from "./iconTour.vue?vue&type=script&lang=js"
export * from "./iconTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports